import { useRef } from "react"
import styled from "styled-components"
import { styled as muistyled, withStyles } from "@material-ui/core/styles"
import { colors, tabletSize, mobileSize, zIndex } from "../../constants"
import IconButton from "@material-ui/core/IconButton"
import assetPrefix from "../../utils/assetPrefix"

export const Root = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  ${zIndex.popup};
`

export const ModalDialog = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-width: 512px;
  max-width: 512px;
  min-height: ${(props) => (props.expand ? "unset" : "10vh")};
  max-height: 90vh;
  border-radius: 5px;
  background-color: ${colors.white};
  overflow-y: auto;
  overflow-x: hidden;
  ${zIndex.popupModal};
  transition: all 0.3s ease-in;
  @media only screen and (max-width: ${tabletSize}) {
    min-width: 512px;
    max-width: 512px;
    min-height: ${(props) => (props.expand ? "unset" : "10vh")};
    max-height: 90vh;
    border-radius: 5px;
    background-color: ${colors.white};
  }
  @media (max-width: ${mobileSize}) {
    border-radius: ${(props) => (props.mobileFullWidth ? "0" : "5px")};
    min-height: ${(props) => (props.mobileFullWidth ? "100%" : props.expand ? "90%" : "10vh")};
    max-height: ${(props) => (props.mobileFullWidth ? "100%" : "90%")};
    min-width: ${(props) => (props.mobileFullWidth ? "100%" : "90%")};
    max-width: ${(props) => (props.mobileFullWidth ? "100%" : "90%")};
    background-color: ${(props) => (props.mobileFullWidth ? colors.black : colors.white)};
  }
`

export const TitleSection = styled.div`
  display: block;
  padding: 24px 30px;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 1px solid ${colors.very_light_pink_five};
  color: ${colors.dark_orange};
  transition: display 0.3s ease-in;
  @media only screen and (max-width: ${tabletSize}) {
    display: block;
  }
  @media only screen and (max-width: ${mobileSize}) {
    display: none;
  }
`

export const CloseBtn = (props) => {
  const ButtonStyled = muistyled(IconButton)({
    position: "absolute",
    top: 8,
    right: 8,
    ["@media (max-width: 767px)"]: {
      padding: 2
    }
  })
  const CloseIcon = useRef(
    styled.img.attrs({
      src: `${assetPrefix}/images/btn-close@3x.png`,
      alt: "Close Icon"
    })`
      width: 30px;
      height: 30px;
    `
  ).current
  return (
    <ButtonStyled {...props}>
      <CloseIcon />
    </ButtonStyled>
  )
}
